import { Pipe, PipeTransform } from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';
import { modelGroupProvider } from '@angular/forms/src/directives/ng_model_group';

@Pipe({
  name: 'formatMaxWeight',
})
export class FormatMaxWeightPipe implements PipeTransform {
  log = debug('app:FormatMaxWeightPipe');

  /**
   * Takes in value like: 80000 and returns 80K
   */
  transform(value, ...args) {
    this.log('input string: ', value);
    if (_.isNumber(value) && value % 1000 === 0) {
      return _.toString(value / 1000) + 'K';
    } else {
      return 'N/A';
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-max-weight/format-max-weight.ts